 document.addEventListener('DOMContentLoaded', function () {
    $('.testimonial-slider').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  });


document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.read-more-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const gallerySelector = btn.getAttribute('data-gallery');
        const gallery = document.querySelector(gallerySelector);

        if (gallery) {
          gallery.classList.toggle('show-all');
          btn.textContent = gallery.classList.contains('show-all') ? 'SHOW LESS' : 'SHOW MORE';
        }
      });
    });
  });



  // For cart quiz


   document.addEventListener('octane.quiz.addToCart', () => {   
const drawer = document.querySelector('cart-drawer');   
if (!drawer) return console.warn(':octagonal_sign: Cart drawer not found.');    

fetch('/?sections=cart-drawer,cart-icon-bubble')     
.then(res => res.json())     
.then(data => {       
const wrapper = document.createElement('div');       
wrapper.innerHTML = data['cart-drawer'];       
const newDrawer = wrapper.querySelector('cart-drawer');       
if (!newDrawer) return 
console.warn(':octagonal_sign: Could not extract <cart-drawer> from section.');        

drawer.replaceWith(newDrawer);        

// Update cart icon bubble       
const newBubbleWrapper = document.createElement('div');       
newBubbleWrapper.innerHTML = data['cart-icon-bubble'];       
const newBubble = 
newBubbleWrapper.querySelector('#cart-icon-bubble');       
const oldBubble = document.querySelector('#cart-icon-bubble');       
if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);        

// Optional event dispatch       
document.dispatchEvent(new CustomEvent('cart:updated'));        

// Open drawer       
newDrawer.style.setProperty('z-index', '999999', 'important');       
newDrawer.open();     })     
.catch(err => 
console.error(':octagonal_sign: Failed to update and open cart drawer:', err)); 
});